<template>
<div class="configureAggregationPoints">
  <div class="content">
    <div class="leftTree">
      <el-input v-model="filterText" placeholder="输入关键字进行过滤"></el-input>
      <el-tree class="filter-tree" :data="treeData" :props="defaultProps" node-key="id" default-expand-all highlight-current :expand-on-click-node="false" :filter-node-method="filterNode" ref="tree" @node-click="handleNodeClick">
        <span class="custom-tree-node" slot-scope="{ node }">
          <span v-if="node.label.length<20">{{ node.label }}</span>
          <el-tooltip v-else effect="light" :content="node.label" :open-delay="500" placement="top">
            <span>{{ node.label }}</span>
          </el-tooltip>
        </span>
      </el-tree>
    </div>
    <div class="rightTable">
      <el-table ref="dataPointTable" :data="tableData" border highlight-current-row height="56vh" @selection-change="handleSelectionChange" style="width: 100%;">
        <el-table-column type="selection" width="55">
        </el-table-column>
        <el-table-column prop="content" label="名称" width="100" show-overflow-tooltip>
          <template slot-scope="{ row }">
            <span v-html="row.content"></span>
          </template>
        </el-table-column>
        <el-table-column prop="fields" label="标识" width="100" show-overflow-tooltip>
          <template slot-scope="{ row }">
            <span v-html="row.fields"></span>
          </template>
        </el-table-column>
        <el-table-column prop="fieldsId" label="编号" show-overflow-tooltip>
          <template slot-scope="{ row }">
            <span v-html="row.fieldsId"></span>
          </template>
        </el-table-column>
        <el-table-column prop="dataType" label="数据类型">
          <template slot-scope="{ row }">
            <span v-html="row.dataType"></span>
          </template>
        </el-table-column>
        <el-table-column prop="dataTypeId" label="点类型">
          <template slot-scope="{ row }">
            <span v-html="row.dataTypeId"></span>
          </template>
        </el-table-column>
        <el-table-column prop="coefficient" label="系数" width="70">
          <template slot-scope="{ row }">
            <span v-html="row.coefficient"></span>
          </template>
        </el-table-column>
        <el-table-column prop="authorization" label="权限" width="60">
          <template slot-scope="{ row }">
            {{ row.authorization == 0 ? "只读" : row.authorization == 1 ? "只写" : "读写" }}
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="165">
          <template slot-scope="{ row }">
            <span v-html="row.createTime"></span>
          </template>
        </el-table-column>
        <el-table-column prop="updateTime" label="修改时间" width="165">
          <template slot-scope="{ row }">
            <span v-html="row.updateTime"></span>
          </template>
        </el-table-column>
        <el-table-column prop="unit" label="单位" width="70">
          <template slot-scope="{ row }">
            <span v-html="row.unit"></span>
          </template>
        </el-table-column>
      </el-table>
      <div v-if="tableData.length>0" style="margin-top: 10px;text-align: center;">
        <el-button type="primary" size="small" @click="allocationCoefficient()">配置系数</el-button>
        <el-button type="success" size="small" @click="generateCoefficient()" style="margin-left: 10%;">生 成</el-button>
      </div>
    </div>
  </div>
  <!-- 配置系数 -->
  <Dialog ref="allocationCoefficientDialog" title="配置系数" dlgWidth="20%">
    <div>
      <span style="margin-left: 10px;">系数:</span>
      <span>
        <el-input v-model="coefficient" placeholder="请输入" style="width: 75%;margin-left: 10px;"></el-input>
      </span>
    </div>
    <span style="display: block;margin-top: 20px;text-align: center;">
      <el-button size="small" @click="closeDialog()">取 消</el-button>
      <el-button type="primary" size="small" @click="onSave()" style="margin-left: 10px;">保 存</el-button>
    </span>
  </Dialog>
</div>
</template>

<script>
import Dialog from '@/components/dialog';
import PROJECTAPI from '@/api/project';
import EquipmentLibraryApi from '@/api/equipmentLibrary';
export default {
  props: {
    projectName: {
      type: [String, Number]
    },
    projectId: {
      type: [String, Number]
    }
  },
  data() {
    return {
      filterText: '',
      treeData: [],
      defaultProps: {
        children: 'childList',
        label(data) {
          return data.type == 1 ? data.emsSn + " (" + data.emsName + ")" : data.equipCode + " (" + data.equipName + ")"
        }
      },
      tableData: [],
      dataTypeList: [{
        id: 0,
        name: '未知'
      }, {
        id: 1,
        name: '遥测'
      }, {
        id: 2,
        name: '遥信'
      }, {
        id: 3,
        name: '遥调'
      }, {
        id: 4,
        name: '遥控'
      }],
      dataTypeIdList: [],
      selectRows: [],
      coefficient: ''
    };
  },
  components: {
    Dialog
  },
  created() {
    this.searchDataFieldTypes();
    this.onSearch();
  },
  mounted() {},
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    }
  },
  methods: {
    //层级类型列表
    searchDataFieldTypes() {
      EquipmentLibraryApi.searchDataFieldTypes().then(res => {
        if (res.data.code == 200) {
          this.dataTypeIdList = res.data.data;
        }
      });
    },
    onSearch() {
      let params = {
        projectId: this.projectId
      }
      PROJECTAPI.getProjectEquipmentTree(params).then(res => {
        if (res.data.code == 200 && !res.data.errors) {
          this.treeData = res.data.data;
        }
        if (res.data.errors) {
          this.$message.error(res.data.errors);
        }
      });
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.type == 1 ? data.emsSn.indexOf(value) !== -1 || data.emsName.indexOf(value) !== -1 : data.equipCode.indexOf(value) !== -1 || data.equipName.indexOf(value) !== -1;
    },
    handleNodeClick(data) {
      this.currTreeData = data;
      if (data.equipId != "") {
        let params = {
          deviceId: data.equipId
        }
        PROJECTAPI.searchProjectEquipFieldsWithVirtual(params).then(res => {
          if (res.data.code == 200) {
            this.tableData = res.data.data;
            for (let i in this.tableData) {
              for (let j in this.dataTypeIdList) {
                if (this.tableData[i].dataTypeId == this.dataTypeIdList[j].id) {
                  this.tableData[i].dataTypeId = this.dataTypeIdList[j].name;
                }
              }
              for (let j in this.dataTypeList) {
                if (this.tableData[i].dataType == this.dataTypeList[j].id) {
                  this.tableData[i].dataType = this.dataTypeList[j].name;
                }
              }
            }
          }
        });
      }
    },
    searchProjectEquipFieldsWithVirtual(data) {
      let params = {
        deviceId: data.equipId
      }
      PROJECTAPI.searchProjectEquipFieldsWithVirtual(params).then(res => {
        if (res.data.code == 200) {
          this.tableData = res.data.data;
          for (let i in this.tableData) {
            if (this.tableData[i].id == this.currFieldId) {
              this.$refs.dataPointTable.setCurrentRow(this.tableData[i]);
            }
            for (let j in this.dataTypeIdList) {
              if (this.tableData[i].dataTypeId == this.dataTypeIdList[j].id) {
                this.tableData[i].dataTypeId = this.dataTypeIdList[j].name;
              }
            }
            for (let j in this.dataTypeList) {
              if (this.tableData[i].dataType == this.dataTypeList[j].id) {
                this.tableData[i].dataType = this.dataTypeList[j].name;
              }
            }
          }
        }
      });
    },
    handleSelectionChange(val) {
      this.selectRows = val;
    },
    allocationCoefficient() {
      this.$refs.allocationCoefficientDialog.open();
      this.coefficient = "";
    },
    closeDialog() {
      this.$refs.allocationCoefficientDialog.close();
      this.coefficient = "";
    },
    onSave() {
      let fieldsInfoIds = [];
      this.selectRows.forEach((item) => {
        fieldsInfoIds.push(item.fieldsId)
      })
      let params = {
        coefficient: this.coefficient,
        deviceId: this.currTreeData.equipId,
        fieldsInfoIds: fieldsInfoIds
      }
      PROJECTAPI.saveProjectEquipmentFieldInfoConfig(params).then(res => {
        if (res.data.code == 200) {
          this.$message.success("保存成功！");
          this.$refs.allocationCoefficientDialog.close();
        }
      });
    },
    generateCoefficient() {
      let fieldsId = [];
      this.selectRows.forEach((item) => {
        fieldsId.push(item.fieldsId)
      })
      let params = {
        deviceId: this.currTreeData.equipId,
        fieldsInfoIds: fieldsId
      }
      PROJECTAPI.takeEffectProjectEquipmentFieldInfoConfig(params).then(res => {
        if (res.data.code == 200) {
          this.$message.success("操作成功！");
        }
      });
    },
  }
};
</script>

<style lang="scss" scoped>
.configureAggregationPoints {
  width: 100%;
  height: 100%;

  .leftTree {
    float: left;
    border-right: 1px solid;
    width: 350px;
    height: 62vh;
    padding-right: 20px;

    .filter-tree {
      height: 95%;
      margin-top: 10px;
      overflow: auto;
    }

    .custom-tree-node {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 14px;
      overflow-x: auto;
      padding-right: 5px;

      &::-webkit-scrollbar {
        height: 5px;
      }
    }

    >>> .el-tree-node__content {
      height: 35px;
      line-height: 25px;
    }
  }

  .rightTable {
    float: left;
    width: calc(100% - 350px);
    padding: 10px 0px 10px 20px;
  }

  .btn {
    padding: 0px;
    font-size: 12px !important;

    &span {
      font-size: 12px !important;
    }
  }

  button.el-button.btn.el-button--text.el-button--mini {
    margin-left: 5px !important;
  }

  >>> .el-input-group__prepend {
    width: 100px;
    background: linear-gradient(135deg, #3897C1 0%, #1D7197 100%);
    color: #fff;
    font-family: PingFang;
    font-weight: 600;
  }

  >>> .el-input-group__append {
    width: 40px;
    background: linear-gradient(135deg, #0561E3 0%, #0049AD 100%);
    border-radius: 0px 4px 4px 0px;
    color: #fff;
  }

  >>> .el-input-group>.el-input__inner {
    border: 1px solid #E7E8EB;
    border: 1px 0px;
    border-radius: 0px !important;
  }

  .keywordClass {
    display: flex;
    flex-direction: row;
    justify-content: center;
  }

  .filterType {
    >>> .el-icon-arrow-up:before {
      color: #fff;
    }

    >>> .el-input__inner {
      background: #FFFFFF linear-gradient(135deg, #3897C1 0%, #1D7197 100%) !important;
      border: 0px !important;
      border-radius: 4px 0px 0px 4px !important;
      box-shadow: 0px 4px 17px 0px rgba(187, 187, 187, 0.5);
      color: #fff;
    }
  }

  .searchKeyClass {
    >>> .el-input__inner {
      border-radius: 0px 4px 4px 0px !important;
    }

    >>> .el-select .el-input__inner:focus,
    >>> .el-select .el-input.is-focus .el-input__inner {
      border-color: #f3f4f5;
    }
  }

  #sector {
    position: absolute;
  }

  #sector .moreIcon {
    margin-left: 5px;
  }

  #sector ul {
    width: 12px;
    position: absolute;
    z-index: 99;
  }

  #sector ul li {
    list-style: none;
    position: absolute;
    background: #ccc;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    left: -18px;
    top: -42px;
    display: flex;
    justify-content: center;
    align-items: center;
    -webkit-transform-origin: 100% 100%;
    -moz-transform-origin: 100% 100%;
    -ms-transform-origin: 100% 100%;
    transform-origin: 100% 100%;
  }

  #sector .sector1 {
    margin-top: -25px;
    -webkit-transform: rotate(90deg);
    -moz-transform: rotate(90deg);
    -ms-transform: rotate(90deg);
    transform: rotate(90deg);

    img:hover {
      transform: scale(1.5);
    }
  }

  #sector .sector2 {
    margin-top: -15px;
    margin-left: 2px;
    // -webkit-transform: rotate(-30deg);
    // -moz-transform: rotate(-30deg);
    // -ms-transform: rotate(-30deg);
    // transform: rotate(-30deg);

    img:hover {
      transform: scale(1.5);
    }
  }

  #sector .sector3 {
    margin-top: 0px;
    margin-left: -12px;
    // -webkit-transform: rotate(-60deg);
    // -moz-transform: rotate(-60deg);
    // -ms-transform: rotate(-60deg);
    // transform: rotate(-60deg);

    img:hover {
      transform: scale(1.5);
    }
  }

  #sector .sector4 {
    margin-top: 20px;
    margin-left: -20px;
    // -webkit-transform: rotate(-90deg);
    // -moz-transform: rotate(-90deg);
    // -ms-transform: rotate(-90deg);
    // transform: rotate(-90deg);

    img:hover {
      transform: scale(1.5);
    }
  }

  #sector .sector5 {
    margin-top: 40px;
    margin-left: -12px;
    // -webkit-transform: rotate(-120deg);
    // -moz-transform: rotate(-120deg);
    // -ms-transform: rotate(-120deg);
    // transform: rotate(-120deg);

    img:hover {
      transform: scale(1.5);
    }
  }

  #sector .sector6 {
    margin-top: 56px;
    margin-left: 1px;
    // -webkit-transform: rotate(-150deg);
    // -moz-transform: rotate(-150deg);
    // -ms-transform: rotate(-150deg);
    // transform: rotate(-150deg);

    img:hover {
      transform: scale(1.5);
    }
  }

  #sector .sector7 {
    margin-top: 66px;
    margin-left: 20px;
    // -webkit-transform: rotate(270deg);
    // -moz-transform: rotate(270deg);
    // -ms-transform: rotate(270deg);
    // transform: rotate(270deg);

    img:hover {
      transform: scale(1.5);
    }
  }

  #sector ul li p {
    position: absolute;
    top: 73px;
    left: 120px;
  }

  .copyBlock {
    background: #ccc;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    margin-left: 16%;
    margin-top: 56px;
    padding: 5px 10px;
    position: fixed;
    z-index: 99;
  }
}
</style>
<style lang="scss">
.el-select-dropdown.el-popper.filterTypePopper {
  background: #FFFFFF linear-gradient(135deg, #3897C1 0%, #1D7197 100%) !important;
  box-shadow: 0px 4px 17px 0px rgba(187, 187, 187, 0.5);
}

.filterTypePopper .el-select-dropdown__item {
  color: #fff;
}

.filterTypePopper .el-select-dropdown__item.selected {
  background: #fff;
  color: #2E81B1;
}

.filterTypePopper .el-select-dropdown__item.hover {
  background: #1D7197;
  color: #fff;
}

.filterTypePopper .popper__arrow {
  display: none !important;
}

button.el-button.moreBtn.el-button--text.el-button--small {
  color: #000;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  margin-left: 20px !important;
  margin-top: 10px !important;
}

button.el-button.moreBtn.el-button--text.el-button--small.is-disabled {
  color: #C0C4CC;
}

button.el-button.searchIcon.el-button--default.el-button--medium {
  background: linear-gradient(135deg, #0561E3 0%, #0049AD 100%);
  color: #fff;
}

.configureAggregationPoints .el-tooltip {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/views/boss/project/configureAggregationPoints.vue